<template>
    <HamletTable
        :columns="columns"
        :fetch="fetch"
        @onRowClick="edit"
    >
        <template #header-controls>
            <div class="d-flex align-items-center">
                <b-form-checkbox
                    id="showNestedServices"
                    v-model="showNestedServices"
                    checked="true"
                    name="check-button"
                    class="mb-0 mr-1"
                    switch
                    inline
                >
                    Show nested services?
                </b-form-checkbox>
                <Button
                    v-if="$can('visit', 'system-security-user-role-create')"
                    class="btn-icon"
                    @click="$router.push({name: 'system-security-user-role-create'})"
                >
                    <feather-icon icon="PlusIcon" />
                </Button>
            </div>
        </template>

        <template #header-label>
            {{ $t('Page(UserRoles):Component(Text):page-label') }}
        </template>

        <template #cell-services="data">
            <b-badge
                v-for="service in data.item.services.filter(s => false === s.nested)"
                :key="'service-' + service.id"
                style="margin-right: 4px"
            >
                {{ service.title }}
            </b-badge>
            <span v-if="showNestedServices">
                <b-badge
                    v-for="service in data.item.services.filter(s => s.nested)"
                    :key="'nested-service-' + service.id"
                    style="margin-right: 4px"
                >
                    {{ service.title }}
                </b-badge>
            </span>
        </template>
    </HamletTable>
</template>

<script>
import { BBadge, BFormCheckbox } from 'bootstrap-vue'
import HamletTable from '@core/components/common/HamletTable.vue'
import { UserApi } from '@core/api'
import { Button } from '@core/components/common'

export default {
    components: {
        BFormCheckbox, HamletTable, BBadge, Button,
    },
    data() {
        return {
            showNestedServices: false,
            columns: [
                { key: 'id', label: this.$t('Component(Grid):column-id') },
                { key: 'title', label: this.$t('Component(Grid):column-name') },
                { key: 'services', label: this.$t('Component(Grid):column-services'), tdClass: 'text-wrap' },
            ],
        }
    },
    methods: {
        fetch(config, cb) {
            UserApi.getSystemRoles().then(r => {
                cb(r.data.length, r.data)
            })
        },
        edit(role) {
            if (this.$can('visit', 'system-security-user-role-card')) {
                this.$router.push({
                    name: 'system-security-user-role-card',
                    params: { id: role.id },
                })
            }
        },
    },
}
</script>
